import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';

export default function GoldBadge({ children, logo }: { children: ReactNode; logo?: string }) {
  return (
    <span
      className={cn(
        'inline-flex items-center border border-white/40 text-gold-ink text-[12.5px] font-semibold rounded-full shadow-[0_2px_6px_rgba(0,0,0,0.2)]',
        logo ? 'pl-1.5 pr-3.5 py-1.5 gap-2' : 'px-3.5 py-1.5',
      )}
      style={{ background: 'linear-gradient(135deg, #E4C078, #B8863C)' }}
    >
      {logo && (
        <span className="shrink-0 w-6 h-6 rounded-full bg-paper flex items-center justify-center overflow-hidden p-0.5">
          <img src={logo} alt="" width={24} height={24} className="w-full h-full object-contain" />
        </span>
      )}
      {children}
    </span>
  );
}
